<template>
  <div class="col-md-6">
    <div class="content">
      <div class="heading ">{{ $t("contact_detail") }}</div>
      <div class="number ">{{ contact.phone }}</div>
      <p class="">
        {{ contact.address }}, <br />
        {{ contact.city }}, {{ contact.country }}
      </p>
      <p class="">{{ contact.shop_email }}</p>
      <ul class="list-content">
        <li class="">
          <p class="text">{{ $t('opening_time') }}:</p>
        </li>
        <li class="">
          <p>{{ $t('monday') }} - {{ $t('sunday') }} : {{ openHour.open_time_hours_from }} - {{ openHour.open_time_hours_to }}</p>
        </li>
        <li class=""><p>{{ $t('delivery') }} : {{ openHour.delivery_time_from }} - {{ openHour.delivery_time_to }}</p></li>
      </ul>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "ContacDetailsComponent",
  props: {
    msg: String,
  },
  data() {
    return {
      contact: {},
      openHour: {},
    };
  },

  mounted() {
    axios
      .get(`${process.env.VUE_APP_BASE_URL}/api/setting`)
      .then((response) => {
        this.contact = response.data;
      })
      .catch((error) => {
        console.error("There was an error fetching the data:", error);
      });

    axios
      .get(`${process.env.VUE_APP_BASE_URL}/api/open-hour`)
      .then((response) => {
        this.openHour = response.data;
      })
      .catch((error) => {
        console.error("There was an error fetching the data:", error);
      });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
